export enum ContractPaymentTypeEnum {
	BACS = 0,
	QuartelyDD = 10,
	Proforma = 20,
	MonthlyDD = 30
}
